<div class="eui-sidebar-menu__container" [class.eui-sidebar-menu__container--collapsed]="isCollapsed" [style]="style">
    <div class="eui-sidebar-menu__content">
        <eui-menu [items]="items"
                [hasFilter]="hasFilter"
                [hasIcons]="hasIcons"
                [hasTooltip]="hasTooltip"
                [isCollapsed]="isCollapsed"
                [expandAllItems]="expandAllItems"
                [fragmentId]="fragmentId"
                [searchFilterLabel]="searchFilterLabel"
                [expandMenuLabel]="expandMenuLabel"
                [collapseMenuLabel]="collapseMenuLabel"
                [externalLinkLabel]="externalLinkLabel"
                (onClicked)="onMenuClicked($event)"
                (onItemClicked)="onMenuItemClicked($event)">
        </eui-menu>
    </div>
</div>
